export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7585.e26a4317.jpg";